import {FC} from 'react'
import {useLang} from './Metronici18n'
import {IntlProvider} from 'react-intl'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/sv'

import enMessages from './messages/en.json'
import svMessages from './messages/sv.json'
import finMessages from './messages/fin.json'
import noMessages from './messages/no.json'

import enTooltip from './tooltips/en.json'

const allMessages = {
  en: enMessages,
  sv: svMessages,
  fin: finMessages,
  no: noMessages,
  'en-tips': enTooltip,
}

const I18nProvider: FC = ({children}) => {
  const locale = useLang()
  const messages = allMessages[locale]

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  )
}

export {I18nProvider}
